import { ApiError } from '@/api/error'

export interface UploadProgressEvent {
  loaded: number
  total: number
  percentage: number
}

export interface UploadOptions {
  url: string
  formData: FormData
  onProgress?: (progress: UploadProgressEvent) => void
}

export function uploadFile(options: UploadOptions): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()

    // プログレス監視
    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable && options.onProgress) {
        const percentage = Math.round((event.loaded / event.total) * 100)
        options.onProgress({
          loaded: event.loaded,
          total: event.total,
          percentage,
        })
      }
    })

    // 完了時の処理
    xhr.addEventListener('load', () => {
      if (xhr.status == 200) {
        resolve()
      } else {
        // HTTPエラー
        reject(
          new ApiError(xhr.statusText || 'HTTP Error', xhr.status, options.url)
        )
      }
    })

    // エラー時の処理
    xhr.addEventListener('error', () => {
      reject(new ApiError('Network Error', xhr.status, options.url))
    })

    // 中断時の処理
    xhr.addEventListener('abort', () => {
      reject(new ApiError('Upload Aborted', 0, options.url))
    })

    // リクエスト設定
    xhr.open('PUT', options.url)
    // Content-Typeは空にする必要がある
    xhr.setRequestHeader('Content-Type', '')

    // アップロード開始
    xhr.send(options.formData)
  })
}

export function uploadLive2DModel(
  uploadUrl: string,
  file: File,
  onProgress?: (progress: UploadProgressEvent) => void
): Promise<void> {
  const formData = new FormData()
  formData.append('zip_file', file)

  return uploadFile({
    url: uploadUrl,
    formData,
    onProgress,
  })
}
